export default "__VITE_ASSET__DwAqdCFr__"